import { fetch } from 'whatwg-fetch';

let session = localStorage.getItem('session') ?? '';

const req = async (method, path, body) => {
  const input = `${process.env.VUE_APP_API_ENDPOINT}${path}`;
  const init = {
    method,
    headers: {},
  };
  if (body instanceof Object) {
    init.headers['content-type'] = 'application/json';
    init.body = JSON.stringify(body);
  }
  if (session !== '') {
    init.headers['x-foxit-session'] = session;
  }
  const response = await fetch(input, init);
  const refresh = response.headers.get('x-foxit-session');
  if (typeof refresh === 'string') {
    localStorage.setItem('session', (session = refresh));
  }
  const mimetype = response.headers.get('content-type');
  if (mimetype.match(/^application\/json/i)) {
    return await response.json();
  }
  return { success: false };
};

export default {
  get: async (path) => await req('get', path),
  post: async (path, body) => await req('post', path, body),
  put: async (path, body) => await req('put', path, body),
  delete: async (path) => await req('delete', path),
};
